<template>
    <div class="p-4">
        <div v-if="loading">
            <div class="clearfix">
                <div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
                <div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
                <div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
            </div>
            <div class="skeleton midnight h32 mb-3"></div>
            <div class="skeleton midnight h32 mb-3"></div>
            <div class="skeleton midnight h32 mb-3"></div>
            <div class="skeleton midnight h32 mb-3"></div>
            <div class="skeleton midnight h32 mb-3"></div>
        </div>
        <div v-else v-html="reportHtml"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            reportHtml: null,
        };
    },
    mounted() {
        this.$cfetch(`${this.$settings.APIBaseURL}/reporting/htmlreport/individual`, {
            cache: false,
            data: {
                student_id: this.$route.params.studentid,
                date_from: this.$route.query.date_from,
                date_to: this.$route.query.date_to,
                teacher: this.$route.query.teacher,
            },
        })
            .then(json => {
                if (json.status === "SUCCESS" && json.html) {
                    this.reportHtml = json.html;
                } else {
                    this.reportHtml = `<div class="alert alert-info">${this.$t('no-data')}</div>`;
                }
            })
            .catch(() => {
                this.reportHtml = `<div class="alert alert-danger">${this.$t('error')}</div>`;
            })
            .finally(() => {
                this.loading = false;
            });
    },
};
</script>
